import { makeStyles } from "@material-ui/core/styles";
const ListStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    padding: 0,
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(29, 78, 216, 0.35)",
      borderRadius: 6,
    },
  },
  brandSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.1),
    padding: theme.spacing(1.25, 1.5, 1.05),
    color: "#fff",
    borderBottom: "1px solid rgba(29, 78, 216, 0.16)",
    marginBottom: theme.spacing(0.5),
  },
  brandBadge: {
    width: 36,
    height: 36,
    borderRadius: 10,
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    color: "#fff",
    fontWeight: 800,
    letterSpacing: "0.04em",
    boxShadow: "0 10px 24px rgba(29, 78, 216, 0.32)",
    flexShrink: 0,
  },
  brandText: {
    minWidth: 0,
  },
  brandTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    lineHeight: 1.1,
    color: "#f8fafc",
  },
  brandSubtitle: {
    fontSize: "0.72rem",
    color: "rgba(226, 232, 240, 0.62)",
    marginTop: 4,
  },
  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    fontWeight: 500,
    color: "#e5e7eb",
    width: "auto",
    margin: theme.spacing(0, 0.8, 0.5),
    padding: theme.spacing(1, 1),
    borderRadius: 12,
    minHeight: 46,
    position: "relative",
    transition:
      "transform 160ms ease, background-color 160ms ease, box-shadow 160ms ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      boxShadow: "0 10px 20px rgba(0, 0, 0, 0.16)",
    },
  },
  iconBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 36,
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "rgba(29, 78, 216, 0.35)",
    border: "1px solid rgba(29, 78, 216, 0.45)",
    margin: 0,
    marginRight: 10,
    flexShrink: 0,
  },
  profileListItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 36,
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "rgba(29, 78, 216, 0.35)",
    border: "1px solid rgba(29, 78, 216, 0.45)",
    margin: 0,
    marginRight: 10,
    flexShrink: 0,
  },
  itemTextWrap: {
    whiteSpace: "initial",
    color: "inherit",
    flex: "0 1 auto",
    maxWidth: "70%",
    margin: 0,
    "& .MuiListItemText-primary": {
      fontSize: "0.9rem !important",
      lineHeight: 1.2,
      fontWeight: "inherit",
      letterSpacing: "0.01em",
      color: "inherit",
    },
  },
  iconImage: {
    height: 22,
    width: 22,
    objectFit: "contain",
    display: "block",
    filter: "brightness(0) saturate(100%) invert(100%)",
  },
  itemToggleIcon: {
    borderWidth: "0 2px 2px 0",
    padding: "6px",
    position: "absolute",
    right: 16,
    border: "solid rgba(29, 78, 216, 0.6)",
    minWidth: "fit-content !important",
    top: "50%",
    transform: "translateY(-50%) rotate(-45deg)",
    "-webkitTransform": "translateY(-50%) rotate(-45deg)",
    transition: "transform 160ms ease, border-color 160ms ease",
    "&.expand": {
      borderColor: "#1d4ed8",
      transform: "translateY(-50%) rotate(45deg)",
      "-webkitTransform": "translateY(-50%) rotate(45deg)",
    },
  },
  selected: {
    fontWeight: 700,
    color: "#fff",
    background: "linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)",
    border: "1px solid rgba(96, 165, 250, 0.55)",
    boxShadow: "inset 3px 0 0 #60a5fa, 0 8px 20px rgba(29, 78, 216, 0.4)",
    "& .MuiListItemIcon-root": {
      background: "transparent",
      border: "none",
      boxShadow: "none",
    },
  },
  ProfileSelected: {
    fontWeight: 700,
    width: "5em",
    color: "#fff",
    background: "linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)",
    border: "1px solid rgba(96, 165, 250, 0.55)",
    "& .MuiListItemIcon-root": {
      background: "transparent",
      border: "none",
      boxShadow: "none",
    },
  },

  profileStyle: {
    marginTop: "auto",
  },
}));

export default ListStyles;
